// extracted by mini-css-extract-plugin
export default {"agentInfoWork":"agentInfoWork_TM9as","onlyText":"onlyText_r43Tv","company":"company__xcZb","isText":"isText_zgHp0","position":"position_skAdl","avatar":"avatar_a6jtF"};